import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { ClientsFilterService } from 'src/app/services/clients-filter.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { ProfileService } from 'src/app/services/profile.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { AlphaNumericOnly, IsValidArray } from 'src/app/validation';
import { isNullOrUndefined } from '../../validation';
import { IsValidPAN } from 'src/app/validation';
import { filter } from 'jszip';
import { debounceTime, distinctUntilChanged, from, of, Subscription, switchMap } from 'rxjs';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { AdminLoginStateService } from 'src/app/services/admin-login-state.service';
import { nonWhiteSpace } from 'html2canvas/dist/types/css/syntax/parser';
import CryptoJS from 'crypto-js';
import { DataOfPnUc } from '../data-of-pn-uc';
declare var $: any;
@Component({
  selector: 'app-clients-filter',
  templateUrl: './clients-filter.component.html',
  styleUrls: ['./clients-filter.component.scss']
})
export class ClientsFilterComponent implements OnInit {
  @Output() FilterData: EventEmitter<any> = new EventEmitter();
  @Output() GetPanUcc: EventEmitter<any> = new EventEmitter();
  @Output() FilterData_MFCentral: EventEmitter<any> = new EventEmitter();
  @Input() isMultiSelect: boolean = false;
  @Input() DDLFilterType: string = 'T';    // Default 'T' is passed -- Added by Saddam
  @Input() HierarchyClient = true;
  @Input() FilterType: string = "byClient"; // i have changed simple FilterType to @Input type
  @Input() SetDefaultClientByID: string = '';
  //Added By Devang Mehta On 12-11-2024
  @Input() ReportSource: string = "";
  @Input() NEWCheckUCCForTranx: boolean = false;
  @Input() IsClientSelected: any = "";
  @Input() IsShowUnmapedFilter: boolean = false;
  ClientName: any;
  ClientPAN: any;
  ClientResult: any = [];
  //End By Devang Mehta
  clientFilterForm: FormGroup;
  ClientDetails: FormGroup;
  LoginId: string;
  UserType: string = "";
  Param1: string = "";
  ClientData: any;
  TempClientData: any;
  FamilyData: any;
  EmployeeData: any;
  EmployeeDataH: any;
  EmployeeSetting = {};
  SelectedEmployee: any;
  SubbrokerData: any;
  HierarchyData: any;
  PlaceData: any;
  PlaceDataALL: any;
  ResponseData: any;
  selectedClient: any;
  @Input() isShowClientFilter: boolean = true;
  isdisplayFamilyName: boolean = true;
  isDisplayClientName: boolean = true;
  SubBrokerName: any = '';

  @Input() isShowEmpSubBrokerFilter: boolean = true;

  isDisplayEmployeeName: boolean = true;
  isDisplaySubBrokerName: boolean = true;
  isDisplayEmpSubBrokerFamilyName: boolean = true;
  isDisplayEmpSubClientName: boolean = true;

  isShowHiearchyFilter: boolean = true;
  IsShowSubbroker: boolean = true;
  ClientDataSetting = {};
  resultDisplayName = [];
  AllEmpData = [];
  result = [];
  selectedItems: any[] = [];
  ChildSubbrokerData: any[] = [];
  IsMobile: boolean = false;
  @Input() CheckUCCForTranx: boolean = false;
  G_ROLEID: number;
  ClientData_Temp: any;  //Added by Saddam : Store ClientData on page load
  FamilData_Temp: any;    //Added by Saddam
  IsHeirarchyEmp: boolean = false;    //Added by Saddam
  CorpIFDFlag: string = '';
  LimitInvestors: Number = 9 // Added by Yaksh
  ShowLimitsInvestor: boolean = false // Added by Yaksh
  HideMinorClients: Boolean = false // Added by Yaksh
  flag_c = ''
  @Input() DashboardUserId: string = '';    //Dashboard UserId
  @Input() DashboardUserRole: string = '';
  @Input() DashboardUserType: string = '';   //Dashboard User Type
  IsbyUnmaped: boolean = false;
  ClientDetailsSubmitted: boolean = false;
  EmpCode: string = "";
  SBCode: string = "";
  //aditya
  IsRdrctClient = false;
  ClietNameWIthID: any = []; // added by anand
  IsTransactionNew_Design: boolean = false;
  IsNewDesign: boolean = false;
  private routerSubscription: Subscription;
  //aditya
  IsAdminRolezero: boolean = false; // for handling page based on userrole
  IsFromReport: boolean = false;
  ClientId: any = "";
  ShowPan: boolean = false;
  ActiveMenu: string;
  //eoc
  @Output() HideReportData: EventEmitter<any> = new EventEmitter();
  isCDR: boolean = false;
  constructor(
    private fb: FormBuilder,
    private encryptDecrypt: EncrdecrService,
    private ClientFilterService: ClientsFilterService,
    private Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private EncrdecrService: EncrdecrService,
    private ProfileService: ProfileService,
    private router: Router,
    private UserRoleState: AdminLoginStateService) {
    this.clientFilterForm = this.fb.group({
      ClientBasicInfoId: [''],
      FamilyId: [''],
      EmpId: [''],
      SubbrokerId: [''],
      HierarchyId: [''],
      PlaceId: [''],
      ChildSubbrokerId: ['']
    });

    this.ClientDetails = this.fb.group({
      Pan: ['', [Validators.required, Validators.pattern(AlphaNumericOnly)]],
      CustId: ['', [Validators.required]],
      Flag: [''],
    });

  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth)
  }
  ngOnInit() {

    this.SetViewPort(window.innerWidth);
    //Added by Tishya for Employee Login CDR
    if (sessionStorage.getItem('qWHWUPDdjECflTMalUPo9w') != '' && sessionStorage.getItem('qWHWUPDdjECflTMalUPo9w') != null && sessionStorage.getItem('qWHWUPDdjECflTMalUPo9w') != undefined) {
      let isCDRstringValue = this.encryptDecrypt.getDecr(sessionStorage.getItem('qWHWUPDdjECflTMalUPo9w'));
      this.isCDR = isCDRstringValue == "1" ? true : false;
      console.log("isCDR=", this.isCDR);
    }
    //Added by Tishya for Employee Login CDR
    // const pathname = window.location.pathname;
    // // Regex to match any path under /reports-new/ except /reports-new/dashboard
    // const regex = /^\/reports-new\/(?!dashboard|aif-transaction-report|pms-transcrion-report|pms-holding-report)(.*)$|^\/reports\/detailed-holding-report$/;

    // if (regex.test(pathname) && )
    // this.IsFromReport = true
    if (window.location.pathname.includes('reports-new/overall-net-sales-report')) {
      this.isDisplayEmpSubBrokerFamilyName = false
      this.isDisplayEmpSubClientName = false
    }
    //added for IIFL - 253, 254 on 25/09/2025
    else if (window.location.pathname.includes('/reports-new/transaction-report-mis')) {
      this.isDisplayEmpSubBrokerFamilyName = false;
      this.isDisplayEmpSubClientName = false;
    }
    else if (window.location.pathname.includes('/reports-new/orderbook-report-mis')) {
      this.isDisplayEmpSubBrokerFamilyName = false;
      this.isDisplayEmpSubClientName = false;
    }
    //end IIFL - 253, 254

    if (window.location.pathname.includes('/transaction-new-latest')) {
      this.IsNewDesign = true
      this.isShowHiearchyFilter = false;
      this.isdisplayFamilyName = false;
    } else {
      this.IsNewDesign = false
    }
    let data = window.location.pathname;
    if (data.includes('/transact-summary/redeem-summary') || data.includes('/transact-summary/switch-summary')
    || data.includes('/transact-summary/stp-summary') || data.includes('/transact-summary/swp-summary')) {
      this.IsNewDesign = true
    } 
    this.IsRdrctClient = (!!sessionStorage.getItem("jtryithsde")) ? true : false;
    console.log("Currently selected item :", this.selectedItems)
    if (this.IsRdrctClient) //usertype based on client or RM when chnge dashbord,aditya
      this.UserType = this.encryptDecrypt.getDecr(sessionStorage.getItem('edcrfvbhunji'));
    else
      this.UserType = this.encryptDecrypt.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));

    if (this.UserType == '2') {
      this.SBCode = this.encryptDecrypt.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
      this.LoginId = this.encryptDecrypt.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'));
    }
    if (this.UserType == '3') {
      this.isShowHiearchyFilter = false;
      if (this.IsRdrctClient)
        this.LoginId = this.encryptDecrypt.getDecr(sessionStorage.getItem('thnjiokgrthn'));
      else
        this.LoginId = this.encryptDecrypt.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'));
    }

    if (this.UserType == '1') {
      this.LoginId = this.encryptDecrypt.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'));
      this.EmpCode = this.encryptDecrypt.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
      if (sessionStorage.getItem('5gE4QWzFXWKewRC') != '' && sessionStorage.getItem('5gE4QWzFXWKewRC') != null && sessionStorage.getItem('5gE4QWzFXWKewRC') != undefined) {
        this.G_ROLEID = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem('5gE4QWzFXWKewRC')));
      }


    }

    if (
      sessionStorage.getItem("kioh298hKh2kj") != null &&
      sessionStorage.getItem("kioh298hKh2kj") != undefined
    ) {
      this.CorpIFDFlag = this.EncrdecrService.getDecr(sessionStorage.getItem('kioh298hKh2kj'))
    }

    console.log('----------------------' + this.UserType)



    //console.log(this.router.url);

    switch (data) {
      case '/reports/Monthly-SIP-collection-report':
        this.isShowClientFilter = false;
        this.isShowClientFilter = false;
        this.isShowHiearchyFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isDisplayEmployeeName = true;
        this.isDisplaySubBrokerName = true;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/dashboard':
        this.isShowClientFilter = false;
        this.isShowClientFilter = false;
        this.isShowHiearchyFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        if (this.UserType == '2') {
          this.isDisplayEmployeeName = false;
          this.IsShowSubbroker = false; // to hide top row's child subbroker(design issue)
        }
        else if (this.UserType == '1') {
          this.isDisplayEmployeeName = true;
        }

        this.isDisplaySubBrokerName = true;
        this.isDisplayEmpSubClientName = false;// riya->false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/Redemption-Report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/Client-FD-PortFolio-Report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/FD-Mobilization-And-Maturity-Report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/Fresh-SIP-Addition':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/MF-Mobilization-Report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/reversal/Rejection-Report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/Final-Mobilization-Report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/FD-Maturity-Report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports/fd-bond-form-entry-report':
        this.isShowClientFilter = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isShowHiearchyFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports-new/client-wise-mobilization':
        // this.isDisplayEmpSubBrokerFamilyName = false;
        // this.isDisplayEmpSubClientName = false;
        // this.HierarchyClient = false;
        // this.isShowClientFilter = false;
        // this.isdisplayFamilyName = false;
        // this.isDisplayClientName = false;
        if (this.UserType == '1') {
          this.isDisplayEmployeeName = true;
          this.isDisplaySubBrokerName = true;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.HierarchyClient = false;
        }
        else {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          // this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;

          if (this.UserType == '2') {
            this.isDisplaySubBrokerName = true;
            // this.isDisplayEmployeeName = true;
          }
          else {
            this.isDisplaySubBrokerName = false;
          }
        }
        break;
      //Added by Saddam
      case '/reports-new/fresh-sip':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports-new/business-mobilization-snapshot':

        if (this.UserType == '1') {
          this.isDisplayEmployeeName = true;
          this.isDisplaySubBrokerName = true;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.HierarchyClient = false;
        }
        else {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          // this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;

          if (this.UserType == '2') {
            this.isDisplaySubBrokerName = true;
            // this.isDisplayEmployeeName = true;
          }
          else {
            this.isDisplaySubBrokerName = false;
          }
        }
        break;
      case '/reports-new/client-wise-aum':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports-new/net-sell-report':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        debugger
        if (this.UserType == "2") {
          this.isDisplayEmployeeName = false;
          this.IsShowSubbroker = false;
          this.isDisplaySubBrokerName = false;
        }
        else {
          this.isDisplayEmployeeName = true;
          this.IsShowSubbroker = true;
          this.isDisplaySubBrokerName = true;
        }
        break;
      case '/reports-new/business-metric':
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        this.isDisplayEmployeeName = true;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        break;
      case '/reports-new/aum-report':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports-new/nature-wise-aum':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      // commented code by Ravi Vaghela
      case '/client-profile':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      // Added by Yaksh
      case '/reports-new/earningreports':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        (this.UserType == '2' || this.DashboardUserType == '2') ? this.isDisplayEmployeeName = false : this.isDisplayEmployeeName = true; //Added by Saddam
        break;
      // Added by Yaksh
      case '/reports-new/investment-summary-report':
        this.ShowLimitsInvestor = true;
        this.isDisplayClientName = true;
        this.isdisplayFamilyName = true;
        this.isShowHiearchyFilter = true;
        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        break;
      case '/reports-new/aof-report':
        if (this.UserType == '3') {
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.HierarchyClient = false;
          this.isShowClientFilter = true;
          this.isdisplayFamilyName = true;
          this.isDisplayClientName = true;
        }
        else {
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayEmpSubClientName = false;
          this.HierarchyClient = false;
          if(!this.isCDR)
            {
              this.isShowClientFilter = false;
            }
          this.isdisplayFamilyName = false;
          this.isDisplayClientName = false;
        }

        break;
      case '/fd/shriram-fd':
        //this.isShowClientFilter = true;
        this.isDisplayClientName = true;
        this.isdisplayFamilyName = true;
        // this.isShowEmpSubBrokerFilter = true;
        this.isShowHiearchyFilter = true;


        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.HideMinorClients = true
        this.DDLFilterType = "FD"
        break;
      //added by Riya
      case '/reports-new/client-wise-aum-new':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports-new/fd-transaction-report':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/reports-new/fd-before-mature-report':
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.HierarchyClient = false;
        this.isShowClientFilter = false;
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        break;
      case '/fd/fd-profile':
        //this.isShowClientFilter = true;
        this.isDisplayClientName = true;
        this.isdisplayFamilyName = true;
        // this.isShowEmpSubBrokerFilter = true;
        this.isShowHiearchyFilter = true;


        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.HideMinorClients = true
        this.DDLFilterType = "FD"
        break
      case "/reports-new/due-sip-Report":
        this.isShowHiearchyFilter = false; //aditya
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        break;
      case '/reports-new/portfolio-report-deatiled':
        this.ShowLimitsInvestor = false;
        this.isDisplayClientName = true;
        this.isdisplayFamilyName = true;
        this.isShowHiearchyFilter = true;
        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        break;
        // Added by Akash on 18122025
        case '/reports-new/fd-dealentry-report':
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayEmpSubClientName = false;
          this.HierarchyClient = false;
          this.isShowClientFilter = false;
          this.isdisplayFamilyName = false;
          this.isDisplayClientName = false;
        break;

      // Added by Akash on 22122025
      case '/reports-new/online-stp-swp-report':
        this.ShowLimitsInvestor = false;
        this.isDisplayClientName = true;
        this.isdisplayFamilyName = false;
        this.isShowHiearchyFilter = false;
        this.isShowClientFilter = true;
        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isShowEmpSubBrokerFilter = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.HierarchyClient = false;
        this.IsFromReport = false;
        break;
        //End added by Akash        
        case '/reports-new/portfolio-report-combine':
        this.ShowLimitsInvestor = false;
        this.isDisplayClientName = true;
        this.isdisplayFamilyName = true;
        this.isShowHiearchyFilter = true;
        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        break;
      default:
        //this.isShowClientFilter = true;
        this.isDisplayClientName = true;
        this.isdisplayFamilyName = true;
        // this.isShowEmpSubBrokerFilter = true;
        this.isShowHiearchyFilter = true;


        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        break;
    }

    if (window.location.pathname.includes('/transaction-new-latest') || window.location.pathname.includes('/risk-profile')) {
      this.isShowHiearchyFilter = false;
      this.isdisplayFamilyName = false;
    }

    this.IsAdminRolezero = !!sessionStorage.getItem('sdg257561gds');

    this.UserRoleState.Menu.subscribe(ActiveMenu => {
      this.ActiveMenu = ActiveMenu; // string
    });
    this.IsFromReport = (['#SIP-STP-SWP', '#Portfolio', '#Online-Status'].includes(this.ActiveMenu))
      && !window.location.pathname.includes('family-portfolio-Report')//'mf', 'aifpms', 'aif', , 'ipo-ncd-report', 'fd' 
      if (window.location.pathname.includes('/transaction-new-latest')) {
        this.IsFromReport = false;
      }
      if (this.isCDR == false ||  !this.isShowClientFilter) {
        this.BindDropdown();
      }
    debugger
    //when user redirected from explore fund to transaction pages
    if (!window.location.pathname.includes('/reports-new/') && !window.location.pathname.includes('/reports/')) {
      try {
        this.selectedClient = JSON.parse(this.encryptDecrypt.getDecr(sessionStorage.getItem('QQX4$E6Qnd')))
      } catch (err) {

      }
    }


    if (this.selectedClient != undefined) {
      this.clientFilterForm.controls['ClientBasicInfoId'].patchValue(`${this.selectedClient.ClientBasicInfoId}`);
      $(".ClientSelect").prop("disabled", true);
      sessionStorage.removeItem('QQX4$E6Qnd')
      this.FilterData.emit(this.selectedClient)
    }
    //Updated By Devang Mehta On 12-11-2024
    if (this.ReportSource == "folio-master-report" || this.ReportSource == "Capital-Gain-Report" || this.ReportSource == "Opening-Closing-Report" || this.ReportSource == "Detailed-Holding-Report" || this.ReportSource == "IPO-NCD" || this.ReportSource == "dp-holding-report") {                // Add IPO-NCD by anand  
      this.ClientDataSetting = {
        singleSelection: true,
        idField: 'ClientBasicInfoId',
        textField: 'clientname',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true,
        closeDropDownOnSelection: true
      };
    }
    else {
      this.ClientDataSetting = this.ShowLimitsInvestor ? {
        singleSelection: false,
        idField: 'ClientBasicInfoId',
        textField: 'clientname',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true,
        limitSelection: this.LimitInvestors
      } : {
        singleSelection: false,
        idField: 'ClientBasicInfoId',
        textField: 'clientname',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
    }


    //Added By Ravi Vaghela
    if (this.FilterType == 'byHierachy') {
      this.onCheck('byHierachy')
    }

    //Added By Anand 
    if (this.FilterType == 'byEmpSubroker') {
      this.onCheck('byEmpSubroker')
    }

    // Dynamic_For_Clients_filter
    if (this.IsAdminRolezero && this.IsFromReport)
      this.HandlePanUcc();
    if (this.isCDR == true && this.isShowClientFilter) {

      if (this.IsFromReport == true) {
        this.FilterType = "ByPan";
        this.MakeVisiblePan();
        this.isdisplayFamilyName = false;
        this.isDisplayClientName = false;
      } else {
        this.FilterType = "byUnmaped";
        this.isDisplayClientName = false;
        this.IsbyUnmaped = true;
        this.isdisplayFamilyName = false;
        this.isDisplayEmployeeName = false;
        this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
      }
    }

    if (this.IsFromReport == true && this.FilterType == "ByPan") {
      
        
      this.isdisplayFamilyName = false;
      this.isDisplayClientName = false;
    } else if (this.IsFromReport == true && this.FilterType == "byUnmaped") {
     
      this.isDisplayClientName = false;
      this.IsbyUnmaped = true;
      this.isdisplayFamilyName = false;
      this.isDisplayEmployeeName = false;
      this.isDisplaySubBrokerName = false;
      this.isDisplayEmpSubClientName = false;
      this.isDisplayEmpSubBrokerFamilyName = false;
    }

  }
  Dynamic_For_Clients_filter() {

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url.includes('/transaction-new-latest')) {
          // document.body.classList.add('IIFL_New_Design bg-white'); 
          $('.IIFL_Dynamic_Class').addClass('IIFL_New_Design bg-white');
        }
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        if (!event.url.includes('/transaction-new-latest')) {
          // document.body.classList.remove('IIFL_New_Design bg-white');
          $('.IIFL_Dynamic_Class').removeClass('IIFL_New_Design bg-white');
        }
      }
    });
  }
  // checkRoute(): void {
  //   
  //   const currentRoute = this.router.url; 
  //   if(currentRoute == '/transaction-new-latest'){
  //     this.IsTransactionNew_Design = true;
  //   }
  //   this.IsTransactionNew_Design = currentRoute === '/transaction-new-latest';
  // }
  ngAfterViewInit() {
    $('select').select2();

    $(".ClientSelect").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });

    $(".ClientSelect").on("change", (e: any) => this.onChangeClient(e));

    $(".FamilySelect").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });
    $(".FamilySelect").on("change", (e: any) => this.onChangeFamily(e));


    $(".EmployeeSelect").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });
    $(".EmployeeSelect").on("change", (e: any) => {
      this.onChangeEmployee(e)
    });

    $(".SubbrokerSelect").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });

    $(".SubbrokerSelect").on("change", (e: any) => this.onChangeSubbroker(e, 'Subbroker'));

    $(".ChildSubbrokerSelect").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });
    $(".ChildSubbrokerSelect").on("change", (e: any) => this.onChangeSubbroker(e, 'ChildSubbroker'));

    $(".HierarchySelect").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });
    $(".HierarchySelect").on("change", (e: any) => this.onChangeHierarchy(e));

    $(".PlaceSelect").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });
    $(".PlaceSelect").on("change", (e: any) => this.onChangePlace(e));
    $(".ClientSelectNew").on("change", (e: any) => this.onChangeClientSelect(e));


    $(".ClientSelectNew").on("select2:open", () => {
      $(".select2-search__field")[0].focus();
    });

  }
  onChangeClient(event: any) {
    debugger
    sessionStorage.setItem('wertyuiop', '1')//disable -enable view dashboard button
    this.UserRoleState.EnableDisable()
    let ClientBasicInfoId = event.target.value;

    if (ClientBasicInfoId != '') {
      this.clientFilterForm.controls['ClientBasicInfoId'].setValue(ClientBasicInfoId);
      let filterData = this.TempClientData.filter(item => item.ClientBasicInfoId == ClientBasicInfoId);
      if (filterData.length > 0) {
        console.log("THis is final filter data: ", filterData)
        if (this.SubbrokerData != undefined && this.SubbrokerData != null && this.SubbrokerData.length > 0) {
          this.SubBrokerName = this.SubbrokerData.find(item => item.SubbrokerCode == filterData[0].SubBrokerCode);
        }
        filterData[0].ClientID = ClientBasicInfoId;
        filterData[0].flag = "Client";
        filterData[0].resultDisplayName = "";

        if (this.SubBrokerName != null && this.SubBrokerName != undefined && this.SubBrokerName != '') {
          filterData[0].SubBrokerName = this.SubBrokerName.SubbrokerName;
        }

        if (this.CheckUCCForTranx) {

          let pan = this.EncrdecrService.setEncr((filterData[0].PANNo).substring(0, 10));
          let Request = {
            PANNo: pan
          }
          this.ProfileService.CheckCVLKRA(Request).subscribe((result: any) => {
            if (result != null) {
              console.log(result)
              if (result.Message != null && result.Message != "" && result.Message.indexOf("Not Authorized") > -1) {
                this.Logout.LogoutUser();
                return;
              }
              else {
                let r = result.ArrayOfResponse;
                if (r.length > 0) {
                  if (r[0].KYCStatus == 1) {
                    this.FilterData.emit(filterData[0]);
                  }
                  else {
                    $(".ClientSelect").val('').trigger('change');
                    this.CallAlertModal("We're currently unable to fetch your KRA status due to a temporary issue with CVL KRA services. If your KRA is already updated, you may proceed with the transaction. Do you want to continue?");
                  }
                }
                else {
                  $(".ClientSelect").val('').trigger('change');
                  this.CallAlertModal("We're currently unable to fetch your KRA status due to a temporary issue with CVL KRA services. If your KRA is already updated, you may proceed with the transaction. Do you want to continue?");
                }
              }
            }
          }, (err: any) => {
            console.log(err)
            this.Loader.hide();
          });
        }
        else {
          this.FilterData.emit(filterData[0]);
        }
      }
    }
    else {
      this.FilterData_MFCentral.emit("");
    }
  }
  onChangeFamily(event: any) {
    debugger
    if (event.target.value != "Deselect") {
      let Family = event.target.value;
      if (this.TempClientData != undefined && this.TempClientData != null && this.TempClientData.length > 0) {
        if (this.ShowLimitsInvestor) {
          this.result = [];
          this.resultDisplayName = [];
          this.selectedItems = [];
          let newfilterdata = {
            ClientID: [],
            flag: "Client",
            resultDisplayName: []
          }
          if (Family) {
            this.isMultiSelect = true
          }
          this.clientFilterForm.controls.ClientBasicInfoId.setValue(this.result.toString());
          this.FilterData.emit(newfilterdata);

        }
        this.ClientData = this.TempClientData.filter(item => item.ClientGroupName == Family);
        if (this.ReportSource == "portfolio-detailed-report") {
          this.result = [];
          this.resultDisplayName = [];
          this.selectedItems = [];
          let ClientFamilyName = "";
          ClientFamilyName = !isNullOrUndefined(this.ClientData[0].ClientGroupName) ? this.ClientData[0].ClientGroupName : "";
          this.isMultiSelect = true
          this.selectedItems = this.ClientData; // this.ClientData.slice(0, 9);
          this.ClientData.forEach(element => {
            this.result.push(element.ClientBasicInfoId)
          });

          let newfilterdata = {
            ClientID: this.result.toString(),
            flag: "Client",
            resultDisplayName: [],
            ClientFamilyName : ClientFamilyName,
            PANNo : ""
          }
         
          this.clientFilterForm.controls.ClientBasicInfoId.setValue(this.result.toString());
          this.FilterData.emit(newfilterdata);
        }
        else if(this.ReportSource == "portfolio-report-combine"){
          this.result = [];
          this.resultDisplayName = [];
          this.selectedItems = [];
          let ClientFamilyName = "";
          ClientFamilyName = !isNullOrUndefined(this.ClientData[0].ClientGroupName)? this.ClientData[0].ClientGroupName : "";
          this.isMultiSelect = true
          this.selectedItems = this.ClientData; // this.ClientData.slice(0, 9);
          this.ClientData.forEach(element => {
            this.result.push(element.ClientBasicInfoId)
          });

          let newfilterdata = {
            ClientID: this.result.toString(),
            flag: "Client",
            resultDisplayName: [],
            ClientFamilyName: ClientFamilyName,
            PANNo: ""
          }

          this.clientFilterForm.controls.ClientBasicInfoId.setValue(this.result.toString());
          this.FilterData.emit(newfilterdata);
        }
        else if(this.ReportSource == "portfolio-report-combine"){
          this.result = [];
          this.resultDisplayName = [];
          this.selectedItems = [];
          let ClientFamilyName = "";
          ClientFamilyName = !isNullOrUndefined(this.ClientData[0].ClientGroupName)? this.ClientData[0].ClientGroupName : "";
          this.isMultiSelect = true
          this.selectedItems = this.ClientData; // this.ClientData.slice(0, 9);
          this.ClientData.forEach(element => {
            this.result.push(element.ClientBasicInfoId)
          });

          let newfilterdata = {
            ClientID: this.result.toString(),
            flag: "Client",
            resultDisplayName: [],
            ClientFamilyName: ClientFamilyName,
            PANNo: ""
          }

          this.clientFilterForm.controls.ClientBasicInfoId.setValue(this.result.toString());
          this.FilterData.emit(newfilterdata);
        }
        else if(this.ReportSource == "portfolio-report-redemption"){
          this.result = [];
          this.resultDisplayName = [];
          this.selectedItems = [];
          let ClientFamilyName = "";

          // 1. Check if data exists and grab only the first record
          if (this.ClientData && this.ClientData.length > 0) {
            const singleClient = this.ClientData[0];

            ClientFamilyName = !isNullOrUndefined(singleClient.ClientGroupName) ? singleClient.ClientGroupName : "";

            // 2. Set MultiSelect to false
            this.isMultiSelect = false;

            // 3. Populate with only the first element
            this.selectedItems = [singleClient];
            // this.result.push(singleClient.ClientBasicInfoId);
          }

          // 4. Prepare the filter data (ID will be a single string, not a comma-separated list)
          let newfilterdata = {
            ClientID: this.result.toString(),
            flag: "Client",
            resultDisplayName: [],
            ClientFamilyName: ClientFamilyName,
            PANNo: ""
          };

          // 5. Update form control and emit
          this.clientFilterForm.controls.ClientBasicInfoId.setValue('');
          this.FilterData.emit(newfilterdata);
        }
        else{
          if (this.ClientData.length == 1) {
            this.ClientFilterService.setClientDropdownData(this.ClientData[0]);
            $('.ClientSelect').val(this.ClientData[0].ClientBasicInfoId).trigger('change');
          }
          else {
            $('.ClientSelect').val('').trigger('change');
          }
        }

      }
    } else {
      if (this.ShowLimitsInvestor) {
        this.result = [];
        this.resultDisplayName = [];
        this.selectedItems = [];
        let newfilterdata = {
          ClientID: [],
          flag: "Client",
          resultDisplayName: []
        }
        this.isMultiSelect = false
        this.clientFilterForm.controls.ClientBasicInfoId.setValue(this.result.toString());
        this.FilterData.emit(newfilterdata);
      }
      this.ClientData = [];
      this.ClientData = this.TempClientData;
      $('.ClientSelect').val('').trigger('change');
    }
  }
  onChangeEmployee(event: any) {

    this.flag_c = "employee"
    // this.ClientData = [];
    // $('.ClientSelect').val('').trigger('change');
    sessionStorage.removeItem("asjkldnakje34234nwbes");
    sessionStorage.setItem('wertyuiop', '1')//disable -enable view dashboard button
    this.UserRoleState.EnableDisable()
    let ID_Code = event.target.value;
    if (this.ShowLimitsInvestor) {
      this.isMultiSelect = false
    }
    if (ID_Code != '') {
      this.clientFilterForm.controls['EmpId'].setValue(ID_Code);
      this.LoginId = ID_Code;
      this.Param1 = 'Direct'
      let EmployeeName = event.target.options[event.target.options.selectedIndex].text
      this.SubbrokerData = [];
      this.ClientData = [''];
      this.TempClientData = [];
      this.FamilyData = [];
      let emp_details = this.EmployeeData.filter(v => { return v.EmpId == ID_Code });
      let emp_role = "";
      let empCode = '';
      if (IsValidArray(emp_details)) {
        emp_role = emp_details[0].Role;
        empCode = emp_details[0].ID_Code;                                // Aded by Anand to get the employee code in the emit method                               
      }
      if (this.isCDR == false ||  !this.isShowClientFilter) {
        this.BindDropdown();
      }
      if (this.isDisplayEmployeeName == true || this.IsHeirarchyEmp == true) {

        let json = {
          "EmployeId": ID_Code,
          "flag": "employee",
          "EmployeeName": EmployeeName,
          "EmpRole": !isNullOrUndefined(emp_role) ? emp_details[0].Role : "",
          "EmpCode": empCode                                                             // Aded by Anand to get the employee code in the emit method
        }
        this.FilterData.emit(json);
      } else {
        if (this.DDLFilterType == 'D') {
          let json = {
            "EmployeId": ID_Code,
            "flag": "employee",
            "EmployeeName": EmployeeName,
            "EmpRole": !isNullOrUndefined(emp_role) ? emp_details[0].Role : "",
            "EmpCode": empCode                                                                     // Aded by Anand to get the employee code in the emit method
          }
          this.FilterData.emit(json);
        }
        else
          this.FilterData.emit(ID_Code);
      }
    }

    // $(".SubbrokerSelect").val('').trigger('change');
    // $(".ChildSubbrokerSelect").val('').trigger('change');
    // $(".ClientSelect").val('').trigger('change');
    this.OnChangeEmployeeClearDropDown();

  }
  onChangeSubbroker(event: any, flag = '') {

    sessionStorage.removeItem("asjkldnakje34234nwbes");
    sessionStorage.setItem('wertyuiop', '1')//disable -enable view dashboard button
    this.UserRoleState.EnableDisable()
    this.OnChangeEmployeeClearDropDown();
    if (this.ShowLimitsInvestor) {
      this.isMultiSelect = false
    }
    let SubbrokerId = event.target.value;
    if (flag == "Subbroker") {
      this.clientFilterForm.controls['ChildSubbrokerId'].setValue("");
    }
    this.flag_c = "subbroker"
    if (SubbrokerId != '') {
      let SubBrokerName = event.target.options[event.target.options.selectedIndex].text;
      let empClient;
      let empClientFam;
      if (flag == "ChildSubbroker") {
        this.clientFilterForm.controls['ChildSubbrokerId'].setValue(SubbrokerId);
      }
      else {
        this.clientFilterForm.controls['SubbrokerId'].setValue(SubbrokerId);
      }
      //Added by Avdhoot For ChildSubBroker
      let ChildFlag = ''
      let IsChildSB = false;   //Master Franchise
      let selected_ifd_data: any[] = [];

      //Master Franchise : Added by Saddam
      if (this.ChildSubbrokerData !== undefined && this.UserType == '2' && this.ChildSubbrokerData.length > 0) {
        ChildFlag = 'ChildSubBroker'

        selected_ifd_data = this.ChildSubbrokerData.filter((e) => {
          return e.SubbrokerId == SubbrokerId;
        });
        console.log("csub", this.ChildSubbrokerData)
        if (selected_ifd_data[0].IsChildSB == true) {
          IsChildSB = true;
        }

        if (selected_ifd_data[0].CorporateIFDFlag != 1 && this.DDLFilterType == 'D') {
          if (IsChildSB == true) {
            this.isdisplayFamilyName = false;
            this.isDisplayClientName = false;
          }
          else {
            this.isdisplayFamilyName = true;
            this.isDisplayClientName = true;
          }
        }
        else {
          this.isdisplayFamilyName = true;
          this.isDisplayClientName = true;
        }
        if (this.DDLFilterType == 'D' && this.UserType == '2') {
          this.isdisplayFamilyName = false;
          this.isDisplayClientName = false
        }
      }

      let data = window.location.pathname;
      data = data.replace("/app", "");

      if ((data == "/client-profile" || data == "/reports-new/earningreports") && flag == "ChildSubbroker") {
        IsChildSB = true;
      }

      let json = {
        "SubBrokerId": SubbrokerId,
        "SubBrokerName": SubBrokerName,
        "flag": "SubBroker",
        "childFlag": ChildFlag,
        "IsChildSB": IsChildSB
      }

      this.FilterData.emit(json)
      if (this.G_ROLEID >= 1 && this.G_ROLEID <= 3 && this.DDLFilterType == 'IP') {
        empClient = this.ClientData;
      }
      else {
        this.ClientData = [];
        this.TempClientData = [];
        this.FamilyData = [];
      }

      this.Param1 = "";
      // setTimeout(() => {
      //   $(".ClientSelect").val('').trigger('change')
      // }, 100);
      this.Loader.show();
      let request: any;
      if (this.UserType == '1' && this.DDLFilterType == 'R') {
        request = {
          "LoginId": SubbrokerId,
          "LoginType": '1-2',
          "FilterType": this.DDLFilterType,
          "Param1": this.Param1,
          "Param2": ""
        }
      }
      else {
        request = {
          "LoginId": SubbrokerId,
          "LoginType": '2',
          "FilterType": this.DDLFilterType,
          "Param1": this.Param1,
          "Param2": ""
        }
      }


      if (this.UserType == '1') {
        this.LoginId = this.encryptDecrypt.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'));
      }
      let body = { data: this.encryptDecrypt.setEncr(JSON.stringify(request)) }
      this.ClientFilterService.WrapperApiCall(body, "/api/ClientFilters/getClientFilters").then(
        (response: any) => {

          let res = JSON.parse(this.EncrdecrService.getDecr(response))
          this.ResponseData = res;
          //console.log(res)
          this.Loader.hide();
          if (res.code == 200) {
            // setTimeout(() => {
            //   $(".ClientSelect").val('').trigger('change');
            //   this.clientFilterForm.controls['ClientBasicInfoId'].setValue('');
            // }, 100);
            console.log(res);
            if (res.ArrayOfResponse[0].ClientDetails.length > 0) {
              if (this.G_ROLEID >= 1 && this.G_ROLEID <= 3 && this.DDLFilterType == 'IP') {
                if (this.isMultiSelect) {
                  this.ClearMultiSelectDDL();
                }

                let sbClient = res.ArrayOfResponse[0].ClientDetails;
                let tempClients = empClient.concat(sbClient);
                this.ClientData = tempClients;
                this.TempClientData = tempClients;
                let filterData = tempClients.filter(item => item.ClientGroupName !== null);
                this.FamilyData = [...new Set(filterData.map(item => item.ClientGroupName))];
              }
              else {
                if (this.isMultiSelect) {
                  this.ClearMultiSelectDDL();
                }

                this.ClientData = res.ArrayOfResponse[0].ClientDetails;
                this.TempClientData = res.ArrayOfResponse[0].ClientDetails;
                let filterData = res.ArrayOfResponse[0].ClientDetails.filter(item => item.ClientGroupName !== null);
                this.FamilyData = [...new Set(filterData.map(item => item.ClientGroupName))];

                if (flag == 'Subbroker') {               //Added by Saddam
                  this.ChildSubbrokerData = [];
                  if (IsValidArray(res.ArrayOfResponse[0].ChildSubBrokers)) {
                    this.ChildSubbrokerData = res.ArrayOfResponse[0].ChildSubBrokers;
                  }
                  console.log("csub", this.ChildSubbrokerData)
                }
              }
            }
            else {
              if (flag == 'Subbroker') {                 //Added by Saddam
                this.ChildSubbrokerData = [];
                if (this.isMultiSelect) {
                  this.ClearMultiSelectDDL();
                }
                if (IsValidArray(res.ArrayOfResponse[0].ChildSubBrokers)) {
                  this.ChildSubbrokerData = res.ArrayOfResponse[0].ChildSubBrokers;
                }
              }
              console.log("csub", this.ChildSubbrokerData)
            }
          }
        }, (err: any) => {
          this.Loader.hide();
          console.log(err);
        })
    }
    $(".FamilySelect").val('').trigger('change');

    //this.setDropDownData();
  }
  onChangeHierarchy(event: any) {

    let HierarchyId = event.target.value;
    this.clientFilterForm.controls['HierarchyId'].setValue(HierarchyId);
    let PlaceDataFilter = this.AllEmpData.filter(item => item.HierarchyName == HierarchyId);
    this.PlaceDataALL = [...new Map(PlaceDataFilter.map(item => [item['PlaceName'], item])).values()]
    this.PlaceDataALL.sort((a, b) => {
      if (a.PlaceName < b.PlaceName) {
        return -1;
      }
      if (a.PlaceName > b.PlaceName) {
        return 1;
      }
      return 0;
    });
    $(".PlaceSelect").val('').trigger('change');
    this.clientFilterForm.controls['PlaceId'].setValue('');
    $(".EmployeeSelect").val('').trigger('change');
    $(".SubbrokerSelect").val('').trigger('change');
    this.clientFilterForm.controls['EmpId'].setValue("");
    this.clientFilterForm.controls['ChildSubbrokerId'].setValue("");
    this.clientFilterForm.controls['SubbrokerId'].setValue("");
    this.EmployeeDataH = []
    this.SubbrokerData = []
    let json = {
      "flag": "hiearchary",
      "hierarchyId": HierarchyId
    }
    this.FilterData.emit(json);
  }
  onChangePlace(event: any) {
    let PlaceId = event.target.value;
    if (PlaceId != '') {
      this.clientFilterForm.controls['PlaceId'].setValue(PlaceId);
      let EmployeeDataall = this.AllEmpData.filter(item => item.PlaceName == PlaceId);
      this.EmployeeDataH = [...new Map(EmployeeDataall.map(item => [item['ID_Code'], item])).values()]

      let json = {
        "flag": "place",
        "placeId": PlaceId
      }
      this.FilterData.emit(json);
    }

    $(".EmployeeSelect").val('').trigger('change');
    $(".SubbrokerSelect").val('').trigger('change');
    this.clientFilterForm.controls['EmpId'].setValue("");
    this.clientFilterForm.controls['ChildSubbrokerId'].setValue("");
    this.clientFilterForm.controls['SubbrokerId'].setValue("");
    this.SubbrokerData = []


    //this.setDropDownData();

  }


  CallDisableTransaction() {
    $("#DisableTranAlertModalNew").modal({ backdrop: "static", keyboard: false });
    //$("#AlertModalContent").text(msg);
  }

  //Added by Dalsukh for SearchBy Unmapped Client 


  omit_special_char(event) {
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      (k >= 48 && k <= 57)
    );
  }

  SearchClient() {

    this.ClientDetailsSubmitted = true;
    if (this.ClientDetails.controls["Pan"].value == "" && this.ClientDetails.controls["CustId"].value == "") { //this.ClientDetails.controls["Pan"].value == "" && this.ClientDetails.controls["CustId"].value == ""

      // this.CallAlertModal("Please Enter Pan Number OR Customer Id")
      return false;
    }
    else if (this.ClientDetails.controls["Pan"].value !== "" && this.ClientDetails.controls["CustId"].value !== "") {
      this.ClientDetails.controls["Pan"].setValue("")
      this.ClientDetails.controls["CustId"].setValue("")
      this.CallAlertModal("Please enter only PAN Number OR Customer ID")
      return false;
    }
    else {
      if (this.ClientDetails.controls["Pan"].value !== "") {
        this.ClientDetails.controls['CustId'].clearValidators();
        this.ClientDetails.controls['CustId'].updateValueAndValidity();
        // var regax = new RegExp(IsValidPAN);
        // if (!regax.test(this.ClientDetails.controls["Pan"].value)) {
        //   // this.CallAlertModal("Please enter valid PAN number.")
        //   return false;
        // }
      }
      else if (this.ClientDetails.controls['CustId'].value !== "") {
        this.ClientDetails.controls['Pan'].clearValidators();
        this.ClientDetails.controls['Pan'].updateValueAndValidity();
        this.ClientDetails.controls['CustId'].clearValidators();
        this.ClientDetails.controls['CustId'].updateValueAndValidity();
      }
      this.Loader.show();
      let request = {
        "PANNo": this.ClientDetails.controls["Pan"].value,
        "CustId": this.ClientDetails.controls["CustId"].value,
        "Flag": this.ClientDetails.controls["Pan"].value !== "" ? "PAN" : "CUSTID"
      }
      console.log(this.IsAdminRolezero && this.IsFromReport);

      this.ClientFilterService.SearchCustomerRM(request).subscribe(
        (res: any) => {
          debugger;
          if (!(this.IsAdminRolezero && this.IsFromReport)) {
            // this.ClientDetails.controls["Pan"].setValue("")
            this.ClientDetails.controls["CustId"].setValue("")
            this.Loader.hide();
            console.log("response is: ", res);
            if (this.isCDR == true) {
              if (res && res?.ID && res.ID == "200") {
                if ((this.UserType == '1' && this.EmpCode !== res.ArrayOfResponse[0]?.EmpCode) ||
                  this.UserType == '2' && this.SBCode !== res.ArrayOfResponse[0]?.SubBrokerCode) {
                  if (res.ArrayOfResponse[0]?.UccCode) {
                    let ClientData = res.ArrayOfResponse[0];
                    ClientData.flag = "Client";
                    ClientData.resultDisplayName = "";
                    // this.ClientDetails.controls["Pan"].disable();
                    sessionStorage.setItem("aefadfwedv", "Unmapped");
                    this.FilterData.emit(ClientData);
                  } else {
                    sessionStorage.setItem("dfjdhfj@52354vs", this.encryptDecrypt.setEncr(this.ClientDetails.controls["CustId"].value))
                    this.CallDisableTransaction()
                  }
                } else {
                  // this.ClientDetails.controls["Pan"].setValue("")
                  // this.ClientDetails.controls["CustId"].setValue("")
                  // this.CallAlertModal("The client is already mapped to you. You can initiate the transaction using steps: Transaction menu > Search by Client > Select Client Name");
                  // this.FilterData.emit(undefined);
                  if (res.ArrayOfResponse[0]?.UccCode) {
                    let ClientData = res.ArrayOfResponse[0];
                    ClientData.flag = "Client";
                    ClientData.resultDisplayName = "";
                    // this.ClientDetails.controls["Pan"].disable();
                    sessionStorage.setItem("aefadfwedv", "Unmapped");
                    this.FilterData.emit(ClientData);
                  } else {
                    sessionStorage.setItem("dfjdhfj@52354vs", this.encryptDecrypt.setEncr(this.ClientDetails.controls["CustId"].value))
                    this.CallDisableTransaction()
                  }
                }

              } else {
                sessionStorage.setItem("dfjdhfj@52354vs", this.encryptDecrypt.setEncr(this.ClientDetails.controls["CustId"].value))
                this.CallAlertModal_Reload("Client does not exists with the criteria you have searched.")
               
                this.FilterData.emit(undefined);
              }
            } else {
              if (res && res?.ID && res.ID == "200") {
                if ((this.UserType == '1' && this.EmpCode !== res.ArrayOfResponse[0]?.EmpCode) ||
                  (this.UserType == '2' && this.SBCode !== res.ArrayOfResponse[0]?.SubBrokerCode)
                
                ) {
                  if (res.ArrayOfResponse[0]?.UccCode) {
                    let ClientData = res.ArrayOfResponse[0];
                    ClientData.flag = "Client";
                    ClientData.resultDisplayName = "";
                    // this.ClientDetails.controls["Pan"].disable();
                    sessionStorage.setItem("aefadfwedv", "Unmapped");
                    this.FilterData.emit(ClientData);
                  } else {
                    sessionStorage.setItem("dfjdhfj@52354vs", this.encryptDecrypt.setEncr(this.ClientDetails.controls["CustId"].value))
                    this.CallDisableTransaction()
                  }
                } else {
                  // this.ClientDetails.controls["Pan"].setValue("")
                  // this.ClientDetails.controls["CustId"].setValue("")
                  this.CallAlertModal("The client is already mapped to you. You can initiate the transaction using steps: Transaction menu > Search by Client > Select Client Name");
                  this.FilterData.emit(undefined);
                }

              } else {
                sessionStorage.setItem("dfjdhfj@52354vs", this.encryptDecrypt.setEncr(this.ClientDetails.controls["CustId"].value))
                this.CallAlertModal_Reload("Client does not exists with the criteria you have searched.")
              
                this.FilterData.emit(undefined);

              }
            }
          }
          else if (this.IsAdminRolezero && this.IsFromReport) {

            if (res && res?.ID && res.ID == "200" && res?.ArrayOfResponse.length > 0) {
              this.ClientId = res.ArrayOfResponse[0].ClientID;
              let ClientData = res.ArrayOfResponse[0];
              ClientData.flag = "Client";
              ClientData.resultDisplayName = "";
              // this.ClientDetails.controls["Pan"].disable();
              sessionStorage.setItem("aefadfwedv", "Unmapped");
              this.FilterData.emit(ClientData);
              this.GetPanUcc.emit({ ClientId: this.ClientId, Isvalid: true });
            }
            else {
              this.CallAlertModal_Reload("Client does not exists with the criteria you have searched.");
              this.ClientId = ""
            }

            this.Loader.hide();
          }
        }, (err: any) => {
          this.Loader.hide();
          this.FilterData.emit(undefined);
          console.log(err);
        })
    }
  }

  onCheck(value: any) {

    sessionStorage.removeItem("vbvxjhvbxvFilterID")
      sessionStorage.removeItem("vbvxjhvbxvFilterType")

    this.Loader.show();

    this.ClientDetailsSubmitted = false;
    this.ShowPan = false;
    let data = window.location.pathname;
    let filterData = {
      ShowTransaction: false,
      FilterType: value
    }
    this.FilterData.emit(filterData)

    //this.setDropDownData();
    setTimeout(() => {
      this.ClearDropDown();
      this.OnChangeEmployeeClearDropDown('ClearAll');
      //Added by Dalsukh
      this.ClientDetails.controls["Pan"].enable();
      this.ClientDetails.controls["Pan"].setValue("")
      this.ClientDetails.controls["CustId"].setValue("")
      // switching the search type must start from a blank investor selection:
      // clear the dropdown model along with the select/de-select toggle state it is derived from
      this.selectedItems = [];
      this.ClientResult = [];
      this.result = [];
      this.resultDisplayName = [];
      this.ClietNameWIthID = [];
      if (this.isMultiSelect) {
        this.ClearMultiSelectDDL();
      }
    }, 100)

    this.FilterType = value;


    setTimeout(() => {
      if (data != '/reports/Monthly-SIP-collection-report' && data != '/reports/fd-bond-form-entry-report'
        && data != '/reports/Final-Mobilization-Report' && data != '/reports/reversal/Rejection-Report'
        && data != '/reports/MF-Mobilization-Report' && data != '/reports/Fresh-SIP-Addition'
        && data != '/reports/FD-Mobilization-And-Maturity-Report' && data != '/reports/Client-FD-PortFolio-Report'
        && data != '/reports/Redemption-Report' && data != '/reports/FD-Maturity-Report' && data != '/client-profile'
        && data != '/reports-new/earningreports') {

        if (this.FilterType == "byEmpSubroker") {
          this.isDisplayEmployeeName = true;
          this.isDisplaySubBrokerName = true;
          this.isDisplayEmpSubClientName = true;
          this.isDisplayEmpSubBrokerFamilyName = true;
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp;
          this.IsbyUnmaped = false;
          if (this.isCDR == false ||  !this.isShowClientFilter) {
            this.BindDropdown();
          }
        } else if (this.FilterType == 'byClient') {
          this.isDisplayClientName = true;
          this.isdisplayFamilyName = true;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp
          this.IsbyUnmaped = false;
          if (this.isCDR == false || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        } else if (this.FilterType == 'byHierachy') {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.IsHeirarchyEmp = true;
          this.IsbyUnmaped = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp
          this.IsbyUnmaped = false;
          if (this.isCDR == false || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        }
        else if (this.FilterType == 'byUnmaped') {
          this.isDisplayClientName = false;
          this.IsbyUnmaped = true;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
        }
      }

      if (data == '/reports-new/client-wise-aum' || data == '/reports-new/net-sell-report' || data == '/reports-new/fresh-sip' || data == '/reports-new/aum-report' || data == 'reports-new/nature-wise-aum'
        || data == '/reports-new/client-wise-aum-new'
        || data == '/reports-new/fd-transaction-report'
        || data == '/reports-new/fd-before-mature-report'
        || data == '/reports-new/fd-dealentry-report'
      ) {   //Added by Saddam  //Added by Saddam

        this.isDisplayClientName = false;
        this.isdisplayFamilyName = false;
        // this.isDisplayEmployeeName = false;
        // this.isDisplaySubBrokerName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        if (this.UserType == "2") {
          this.isDisplayEmployeeName = false;
          this.IsShowSubbroker = false;
          this.isDisplaySubBrokerName = false;
        }
        else {
          this.isDisplayEmployeeName = true;
          this.IsShowSubbroker = true;
          this.isDisplaySubBrokerName = true;
        }
      }

      if (data == '/client-profile') {

        if (this.FilterType == 'byHierachy') {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.IsHeirarchyEmp = true;
        } else {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayEmployeeName = true;
          this.isDisplaySubBrokerName = true;
        }
      }
      if (data == '/reports-new/earningreports') {

        if (this.FilterType == 'byHierachy') {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.IsHeirarchyEmp = true;
        } else {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayEmployeeName = true;
          this.isDisplaySubBrokerName = true;
        }
      }

      if (data == '/reports-new/business-metric') {
        this.isDisplayClientName = false;
        this.isdisplayFamilyName = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplaySubBrokerName = false;
      }

      if (data == '/reports-new/business-mobilization-snapshot' || data == '/reports-new/client-wise-mobilization') {
        if (this.UserType == '1') {
          if (this.FilterType == 'byHierachy') {
            this.isDisplayEmployeeName = false;
            this.isDisplaySubBrokerName = false;
            this.IsHeirarchyEmp = true;
          }
          else {
            this.isDisplayEmployeeName = true;
            this.isDisplaySubBrokerName = true;
          }
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.HierarchyClient = false;
        }
        else {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          // this.isDisplayEmployeeName = false;
          // this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;

          if (this.UserType == '2') {
            this.isDisplaySubBrokerName = true;
          }
          else {
            this.isDisplaySubBrokerName = false;
          }
        }
      }
      // if (data == '/transaction-new/lumpsum' || data == '/transaction-new/sip'
      // || data == '/transaction-new/swp' || data == '/transaction-new/stp'
      // || data == '/explore-funds-new' || data == '/clients-new'
      // || data == '/SGB/SGBInvest' || data == '/SGB/SGBOrderBook'
      // || data == '/fd/fixed_deposite' || data == '/fd/fd-profile'
      // || data == '/fd/fd-orderbook' || data == '/fd/bajajfd-orderbook'
      // || data == '/goal-based-investing/park-money' || data == '/goal-based-investing/create-wealth') {
      //   if (this.FilterType == "byEmpSubroker") {
      //     this.isDisplayEmployeeName = true;
      //     this.isDisplaySubBrokerName = true;
      //     this.isDisplayEmpSubClientName = true;
      //     this.isDisplayEmpSubBrokerFamilyName = true;
      //     this.isDisplayClientName = false;
      //     this.isdisplayFamilyName = false;
      //   } else if (this.FilterType == 'byClient') {
      //     this.isDisplayClientName = true;
      //     this.isdisplayFamilyName = true;
      //     this.isDisplayEmployeeName = false;
      //     this.isDisplaySubBrokerName = false;
      //     this.isDisplayEmpSubClientName = false;
      //     this.isDisplayEmpSubBrokerFamilyName = false;
      //   } else if (this.FilterType == 'byHierachy') {
      //     this.isDisplayClientName = false;
      //     this.isdisplayFamilyName = false;
      //     this.isDisplayEmployeeName = false;
      //     this.isDisplaySubBrokerName = false;
      //     this.isDisplayEmpSubClientName = false;
      //     this.isDisplayEmpSubBrokerFamilyName = false;
      //   }
      // }  

      if (data == '/reports-new/Active-Register-SIP-Report') {
        this.HierarchyClient = false;
        this.isDisplayEmpSubClientName = false;
        this.isDisplayEmpSubBrokerFamilyName = false;
      }
      if (data == '/reports-new/overall-net-sales-report') {
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
      }
      //added for IIFL - 253, 254 on 25/09/2025
      else if (data == '/reports-new/transaction-report-mis') {
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
      }
      else if (data == '/reports-new/orderbook-report-mis') {
        this.isDisplayEmpSubBrokerFamilyName = false;
        this.isDisplayEmpSubClientName = false;
      }
      //end IIFL - 253, 254

      if (data == "/reports-new/orderbook-report") {
        if (this.FilterType == "byEmpSubroker") {
          this.isDisplayEmployeeName = true;
          this.isDisplaySubBrokerName = true;
          this.isDisplayEmpSubClientName = true;
          this.isDisplayEmpSubBrokerFamilyName = true;
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp;
          this.IsbyUnmaped = false;
          if (this.isCDR == false || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        } else if (this.FilterType == 'byClient') {
          this.isDisplayClientName = true;
          this.isdisplayFamilyName = true;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp
          this.IsbyUnmaped = false;
          if (this.isCDR || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        } else if (this.FilterType == 'byHierachy') {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.IsHeirarchyEmp = true;
          this.IsbyUnmaped = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp
          this.IsbyUnmaped = false;
          if (this.isCDR == false || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        }
      }

      if ((data != null && data != undefined) && (data.includes("/transaction-new-latest"))) {
        if (this.FilterType == "byEmpSubroker") {
          this.isDisplayEmployeeName = true;
          this.isDisplaySubBrokerName = true;
          this.isDisplayEmpSubClientName = true;
          this.isDisplayEmpSubBrokerFamilyName = true;
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp;
          this.IsbyUnmaped = false;
          if (this.isCDR == false || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        } else if (this.FilterType == 'byClient') {
          this.isDisplayClientName = true;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp
          this.IsbyUnmaped = false;
          if (this.isCDR == false || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        } else if (this.FilterType == 'byHierachy') {
          this.isDisplayClientName = false;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.IsHeirarchyEmp = true;
          this.IsbyUnmaped = false;
          //Added by Saddam
          this.ClientData = this.ClientData_Temp;
          this.TempClientData = this.ClientData_Temp;
          this.FamilyData = this.FamilData_Temp
          this.IsbyUnmaped = false;
          if (this.isCDR == false || !this.isShowClientFilter) {
            this.BindDropdown();
          }
        } else if (this.FilterType == 'byUnmaped') {
          this.isDisplayClientName = false;
          this.IsbyUnmaped = true;
          this.isdisplayFamilyName = false;
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
          this.isDisplayEmpSubClientName = false;
          this.isDisplayEmpSubBrokerFamilyName = false;
        }
      }
      if (data == '/reports-new/net-sell-report') {
        if (this.UserType == "2") {
          this.isDisplayEmployeeName = false;
          this.IsShowSubbroker = false;
          this.isDisplaySubBrokerName = false;
        }
        else if (this.FilterType == 'byHierachy') {
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
        }
      }
      if (data == '/reports-new/client-wise-aum-new') {
        if (this.UserType == "1" && this.FilterType == 'byHierachy') {
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
        }
      }
      if (data == '/reports-new/fd-transaction-report') {
        if (this.UserType == "1" && this.FilterType == 'byHierachy') {
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
        }
      }
      if (data == '/reports-new/fd-before-mature-report') {
        if (this.UserType == "1" && this.FilterType == 'byHierachy') {
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
        }
      }
      if (data == '/reports-new/aum-report') {
        if (this.UserType == "1" && this.FilterType == 'byHierachy') {
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
        }
      }
      if (data == '/reports-new/client-wise-aum') {
        if (this.UserType == "1" && this.FilterType == 'byHierachy') {
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
        }
      }
      if (data == "/reports-new/nature-wise-aum") {
        if (this.UserType == "1" && this.FilterType == 'byEmpSubroker') {
          this.isDisplayEmpSubBrokerFamilyName = false;
          this.isDisplayEmpSubClientName = false;
        }
      }
      if (data == '/reports-new/fd-dealentry-report') {
        if (this.UserType == "1" && this.FilterType == 'byHierachy') {
          this.isDisplayEmployeeName = false;
          this.isDisplaySubBrokerName = false;
        }
      }
    }, 150)
    if (data == '/reports-new/client-wise-aum-new') {

    }
    else if (data == '/reports-new/fd-transaction-report') {

    }
    else if (data == '/reports-new/fd-before-mature-report') {

    }
    else if (data == '/reports-new/fd-dealentry-report') {

    }
    else {
      this.Loader.hide();
    }
  }
  ClearDropDown() {

    $(".ClientSelect").prop("disabled", false);
    this.ClientData = [];
    this.ClientData = this.TempClientData;
    $('select').val('').trigger('change.select2');
    this.clientFilterForm.patchValue({
      ClientBasicInfoId: '',
      FamilyId: '',
      EmpId: '',
      SubbrokerId: '',
      HierarchyId: '',
      PlaceId: ''
    }
    );
    this.ChildSubbrokerData = [];
    this.SubbrokerData = [];
  }

  OnChangeEmployeeClearDropDown(flag: string = '') {
    $(".ClientSelect").prop("disabled", false);
    this.ClientData = [];

    if (flag != 'ClearAll')
      this.ClientData = this.TempClientData;

    $('.ClientSelect').val('').trigger('change.select2');

    this.clientFilterForm.patchValue({
      ClientBasicInfoId: '',
      FamilyId: '',
    }
    );
  }

  BindDropdown() {


    this.Loader.show();


    // setTimeout(() => {
    //   $(".ClientSelect").val('').trigger("change");
    // }, 1500);
    //Added by riya
    let login;
    let utype;
    if (!!sessionStorage.getItem("jtryithsde")) { //is client or not
      login = this.EncrdecrService.getDecr(sessionStorage.getItem('thnjiokgrthn'))
      utype = 3
    }
    else {
      login = this.LoginId;
      utype = this.UserType;
    }

    let request = {
      "LoginId": login, //this.LoginId,
      "LoginType": utype,//this.UserType,
      "FilterType": this.DDLFilterType,
      "Param1": '',
      "Param2": ""
    }

    if (this.UserType == '1') {
      this.LoginId = this.encryptDecrypt.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL'));
    }
    let body = { data: this.encryptDecrypt.setEncr(JSON.stringify(request)) }
    this.ClientFilterService.WrapperApiCall(body, "/api/ClientFilters/getClientFilters").then(
      (response: any) => {
        let res = JSON.parse(this.EncrdecrService.getDecr(response))
        let DashboardUserRole = "";
        this.ResponseData = res;
        //console.log(res)
        this.Loader.hide();
        if (res.code == 200) {
          console.log(res);

          if (this.isMultiSelect) {
            this.ClearMultiSelectDDL();
          }


          if (this.DDLFilterType == 'D' && this.UserType == '1') {
            if (IsValidArray(res.ArrayOfResponse[0].ClientDetails)) {
              var emp_details = res.ArrayOfResponse[0].ClientDetails.at(-1);
              DashboardUserRole = emp_details.EmpRole;
              res.ArrayOfResponse[0].ClientDetails.splice(-1, 1);
              res.ArrayOfResponse[0].ClientDetails.EmpRole = DashboardUserRole;
            }
          }


          if (IsValidArray(res.ArrayOfResponse[0].ClientDetails)) {


            this.ClientData = res.ArrayOfResponse[0].ClientDetails;

            if (!!sessionStorage.getItem("jtryithsde")) {
              let clientId = this.EncrdecrService.getDecr(sessionStorage.getItem('thnjiokgrthn'))
              this.selectedItems = this.ClientData.filter(client => client.ClientBasicInfoId == clientId)
            }
            this.TempClientData = res.ArrayOfResponse[0].ClientDetails;

            this.ClientData_Temp = res.ArrayOfResponse[0].ClientDetails;
            let filterData = res.ArrayOfResponse[0].ClientDetails.filter(item => item.ClientGroupName !== null);
            this.FamilyData = [...new Set(filterData.map(item => item.ClientGroupName))];

            if (this.DashboardUserRole != "1" && DashboardUserRole != "1" && this.DashboardUserRole != "" && DashboardUserRole != "") {
              // let FromDashboard = sessionStorage.getItem("hgWUIy487$mJwue");
              // if (FromDashboard != null && FromDashboard != undefined) {
              //   let rr = this.EncrdecrService.getDecr(FromDashboard).split('#*#');
              //   let k = this.ClientData.find(a => a.ClientBasicInfoId == parseInt(rr[0]));
              //   setTimeout(() => {
              //     if (rr[3] == 's') {
              //       $('.ClientSelect').val(k.ClientBasicInfoId).trigger('change');
              //     }
              //     else {
              //       $('#ddlClient ul.item1 li:nth-child(1)').trigger('click');
              //     }
              //   }, 1000);
              // }
            }

            this.FamilData_Temp = this.FamilyData;

            //Added by Avdhoot to bind Logged in Client
            if (this.UserType == '3' || this.DashboardUserType == '3') {

              if (this.SetDefaultClientByID == '') {
                setTimeout(() => {
                  if (this.isMultiSelect) {
                    let tempClientData: any;

                    if (this.DashboardUserId != "")
                      tempClientData = this.ClientData.filter(item => item.ClientBasicInfoId == this.DashboardUserId);
                    else
                      tempClientData = this.ClientData.filter(item => item.ClientBasicInfoId == this.LoginId);
                    this.selectedItems = [
                      { ClientBasicInfoId: tempClientData[0].ClientBasicInfoId, clientname: tempClientData[0].clientname },
                    ];
                    let obj = {
                      ClientBasicInfoId: tempClientData[0].ClientBasicInfoId,
                      clientname: tempClientData[0].clientname
                    }
                    this.onItemSelect(obj)
                  }
                  else {
                    $(".ClientSelect").val(this.LoginId).trigger("change");
                  }

                }, 1000);
              }
            }
          }
          if (IsValidArray(res.ArrayOfResponse[0].SubbrokerDetails)) {
            this.SubBrokerName = '';
            this.clientFilterForm.get('SubbrokerId').setValue('')
            this.SubbrokerData = res.ArrayOfResponse[0].SubbrokerDetails;
          }




          if (IsValidArray(res.ArrayOfResponse[0].EmployeeDetails)) {

            let filterData = res.ArrayOfResponse[0].EmployeeDetails.filter(item => item.ID_Code !== null);
            this.AllEmpData = filterData;
            if (this.clientFilterForm.controls["EmpId"].value == "") {
              this.EmployeeData = [...new Map(filterData.map(item => [item['ID_Code'], item])).values()]
            }

            debugger
            if (this.PlaceData == null || this.PlaceData == undefined) {
              this.PlaceData = [...new Map(filterData.map(item => [item['PlaceName'], item])).values()]

              if (!isNullOrUndefined(this.PlaceData)) {
                this.PlaceDataALL = this.PlaceData;
                this.PlaceDataALL.sort((a, b) => {
                  if (a.PlaceName < b.PlaceName) {
                    return -1;
                  }
                  if (a.PlaceName > b.PlaceName) {
                    return 1;
                  }
                  return 0;
                });
              }
            }
            let HierarchyData = [...new Map(filterData.map(item => [item['HierarchyName'], item])).values()];


            if (!isNullOrUndefined(HierarchyData)) {
              debugger
              if (this.HierarchyData == null || this.HierarchyData == undefined) {
                this.HierarchyData = HierarchyData;


                this.HierarchyData.sort((a, b) => {
                  if (a.HierarchyName < b.HierarchyName) {
                    return -1;
                  }
                  if (a.HierarchyName > b.HierarchyName) {
                    return 1;
                  }
                  return 0;
                });
              }
            }
          }


          if (IsValidArray(res.ArrayOfResponse[0].ChildSubBrokers) && (this.flag_c == "subbroker" || this.UserType == '2')) {
            this.ChildSubbrokerData = res.ArrayOfResponse[0].ChildSubBrokers;

          }
          if (this.DDLFilterType == 'D' && this.UserType == '2') {
            this.SubbrokerData = [{
              "IsChildSB": sessionStorage.getItem("ZhdfjU423HG878"),
              "SubbrokerCode": this.EncrdecrService.getDecr(sessionStorage.getItem("Hldq31TLYwRbLJ8")),
              "SubbrokerId": this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL")),
              "SubbrokerName": this.EncrdecrService.getDecr(sessionStorage.getItem("V4WGROuLLBE6t98"))
            }]
          }

          //It will bind dashboard user : Added by Saddam
          // if ((this.UserType == '1' || this.UserType == '2') && this.DashboardUserRole != '1' && this.DDLFilterType != 'D') {
          //   try {
          //     let FromDashboard = sessionStorage.getItem("hgWUIy487$mJwue");
          //     let data: any;
          //     if (!isNullOrUndefined(FromDashboard))
          //       data = this.EncrdecrService.getDecr(FromDashboard).split('#*#');

          //     if (!isNullOrUndefined(data)) {
          //       if (data[1].trim() == '2') {
          //         setTimeout(() => {

          //           $(".SubbrokerSelect").val(this.DashboardUserId).trigger("change");
          //         }, 1000);
          //       }
          //       else if (data[1].trim() == '1') {
          //         setTimeout(() => {

          //           $(".EmployeeSelect").val(this.DashboardUserId).trigger("change");
          //         }, 1000);
          //       }
          //       else if (data[1].trim() == '3') {
          //         setTimeout(() => {

          //           $(".ClientSelect").val(this.DashboardUserId).trigger("change");
          //         }, 1000);
          //       }
          //     }
          //   } catch (error) {
          //     console.log(error);
          //   }
          // }
          //Added by Avdhoot to Bind Employee and SubBroker selected from Client List Page
          try {
            debugger
            if (!isNullOrUndefined(sessionStorage.getItem("EMP#*sdf234"))) {
              let EmpData = JSON.parse(this.encryptDecrypt.getDecr(sessionStorage.getItem("EMP#*sdf234")))
              sessionStorage.removeItem("EMP#*sdf234");
              setTimeout(() => {
                $(".EmployeeSelect").val(EmpData.EmployeId).trigger('change');
                sessionStorage.removeItem("EMP#*sdf234")
              }, 100);
              if (EmpData.EmployeId) {
                $('.EmployeeSelect').prop('disabled', true)
                $('.SubbrokerSelect').prop('disabled', true)
              }
              this.isShowHiearchyFilter = false;

            }
            else {
              if (!isNullOrUndefined(sessionStorage.getItem("SBK#*sdf234"))) {
                let SBData = JSON.parse(this.encryptDecrypt.getDecr(sessionStorage.getItem("SBK#*sdf234")))
                this.isShowHiearchyFilter = false;
                if (SBData.SubBrokerId) {
                  $('.SubbrokerSelect').prop('disabled', true)
                  $('.EmployeeSelect').prop('disabled', true)
                  $('.ChildSubbrokerSelect').prop('disabled', true)
                }
                sessionStorage.removeItem("SBK#*sdf234");
                setTimeout(() => {
                  $(".SubbrokerSelect").val(SBData.SubBrokerId).trigger('change');
                  sessionStorage.removeItem("SBK#*sdf234")
                }, 100);
              }
            }
          }
          catch (err) {

          }
        }
      }, (err: any) => {
        this.Loader.hide();
        console.log(err);
      })
    this.flag_c = '';
  }

  setDropDownData() {

    this.ClientFilterService.setSelectedDropdownData(this.clientFilterForm.value);
  }


  onItemSelect(e: any) {

    this.ClearClientDetails();
    const ClientId = e.ClientBasicInfoId;
    const clientName = e.clientname;

    this.ClientName = clientName.split('-')[0].trim();
    this.ClientPAN = clientName.split('-')[1].trim();

    if (ClientId) {
      const i = this.result.indexOf(ClientId);
      if (i === -1) {
        if (this.result.length > 0) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else {
          this.resultDisplayName.push(clientName);
        }
        this.ClietNameWIthID.push(ClientId + '|' + clientName);    // added by Anand 04022025
        this.result.push(ClientId);
      } else {
        this.result.splice(i, 1);
        this.resultDisplayName.splice(i, 1);
        if (this.result.length > 1) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else {
          this.resultDisplayName = [];
          this.resultDisplayName.push(clientName);
        }
      }
      this.clientFilterForm.controls.ClientBasicInfoId.setValue(this.result.toString());

      let filterData = [];
      if (this.result.length > 1) {
        filterData = this.TempClientData.filter((item) => this.result.includes(item.ClientBasicInfoId));
        //Added by Dalsukh 02122024

        filterData[0].PANNo = "";
      } else {
        filterData = this.TempClientData.filter(item => item.ClientBasicInfoId == this.result[0]);
        //Added by Dalsukh 02122024
        if (filterData.length > 0) {
          filterData[0].PANNo = this.ClientPAN
        }
      }

      if (this.result.length > 0) {
        filterData[0].ClientID = this.result;
        filterData[0].flag = "Client";
        filterData[0].resultDisplayName = this.resultDisplayName;
        filterData[0].ClietNameWIthID = this.ClietNameWIthID;         // added by Anand 04022024
      } else {
        this.resultDisplayName = [];
        filterData = [{ "ClientID": "", "resultDisplayName": this.resultDisplayName }];

      }
      this.FilterData.emit(filterData[0]);
      console.log("filterData", filterData);


    }
  }

  onItemSelectDeselectAll(items: any, para: number) {

    this.ClearClientDetails();
    switch (para) {
      case 0:
        this.result = [];
        this.resultDisplayName = [];
        // this.selectedItems=[];
        this.resultDisplayName.push('All');
        items.map(item => {

          this.ClietNameWIthID.push(item.ClientBasicInfoId + '|' + item.clientname);         // added by Anand 04022024
          this.result.push(item.ClientBasicInfoId);
        });
        break;
      case 1:
        this.result = [];
        this.resultDisplayName = [];
        this.selectedItems = [];
        break;
    }

    let filterData = this.TempClientData;
    filterData[0].ClientID = this.result;
    filterData[0].flag = "Client";
    filterData[0].resultDisplayName = this.resultDisplayName;
    //Added by Dalsukh 02122024
    filterData[0].ClietNameWIthID = this.ClietNameWIthID;   //added by anand
    filterData[0].PANNo = "";
    console.log(filterData);

    this.clientFilterForm.controls.ClientBasicInfoId.setValue(this.result.toString());
    this.FilterData.emit(filterData[0]);

  }

  ClearClientDetails() {
    this.clientFilterForm.controls.ClientBasicInfoId.setValue("");
  }
  CallAlertModal(msg: any) {
    $("#AlertModal").modal({
      backdrop: "static",
      keyboard: false,
    });
    $("#AlertModalContent").text(msg);
  }
  CallAlertModal_Reload(msg: any) {
    $("#AlertModal_Reload").modal({
      backdrop: "static",
      keyboard: false,
    });
    $("#AlertModalContent_Reload").text(msg);
  }
  GoToClientProfile() {
    this.router.navigateByUrl('/clients');

  }
  get D() {
    return this.ClientDetails.controls;
  }

  // Clear Multi-Select previously selected values : Added by Saddam
  ClearMultiSelectDDL() {
    let filterData = [];
    this.resultDisplayName = [];
    this.ClientData = [];
    this.selectedItems = [];
    this.result = [];
    this.ClientResult = [];
    filterData = [{ "ClientID": "", "resultDisplayName": this.resultDisplayName }];
    this.FilterData.emit(filterData[0]);
  }
  //Added By Devang Mehta On 12-11-2024
  onSelectClientL(e: any, isDeSelect: boolean = false) {
    this.ClearClientDetails();

    if (isDeSelect) {
      // Unselecting the investor was previously routed through the same select-item
      // branch below, which re-emitted the just-removed client's FilterData instead of
      // clearing it - leaving the report page still pointed at the old investor.
      this.ClientResult = [];
      this.FilterData.emit({ ClientBasicInfoId: '', clientname: '', flag: 'Client' });
      return;
    }

    let value = e.ClientBasicInfoId;
    let text = e.clientname;

    this.ClientName = text.split('-')[0].trim();
    this.ClientPAN = text.split('-')[1].trim();
    if (value) {
      let i = this.ClientResult.indexOf(value);
      if (i == -1) {
        this.ClientResult = [];
        this.ClientResult.push(value);
      } else {
        // this.ClientResult.splice(i, 1);
        this.ClientResult = [];
      }
      console.log("Client result: ", this.ClientResult);
      let ClientBasicInfoId = value;
      if (this.ClientResult.length > 0) {
        this.clientFilterForm.controls['ClientBasicInfoId'].setValue(ClientBasicInfoId);
        let filterData = this.TempClientData.filter(item => item.ClientBasicInfoId == ClientBasicInfoId);
        if (filterData.length > 0) {

          if (this.SubbrokerData != undefined && this.SubbrokerData != null && this.SubbrokerData.length > 0) {
            this.SubBrokerName = this.SubbrokerData.find(item => item.SubbrokerCode == filterData[0].SubBrokerCode);
          }
          filterData[0].ClientID = ClientBasicInfoId;
          filterData[0].flag = "Client";
          filterData[0].resultDisplayName = "";
          //Added by Dalsukh 02122024
          filterData[0].PANNo = this?.ClientPAN;

          if (this.SubBrokerName != null && this.SubBrokerName != undefined && this.SubBrokerName != '') {
            filterData[0].SubBrokerName = this.SubBrokerName.SubbrokerName;
          }

          if (this.CheckUCCForTranx) {

            let pan = this.EncrdecrService.setEncr((filterData[0].PANNo).substring(0, 10));
            let Request = {
              PANNo: pan
            }
            this.ProfileService.CheckCVLKRA(Request).subscribe((result: any) => {
              if (result != null) {
                console.log(result)
                if (result.Message != null && result.Message != "" && result.Message.indexOf("Not Authorized") > -1) {
                  this.Logout.LogoutUser();
                  return;
                }
                else {
                  let r = result.ArrayOfResponse;
                  if (r.length > 0) {
                    if (r[0].KYCStatus == 1) {
                      this.FilterData.emit(filterData[0]);
                    }
                    else {
                      $(".ClientSelect").val('').trigger('change');
                      this.CallAlertModal("We're currently unable to fetch your KRA status due to a temporary issue with CVL KRA services. If your KRA is already updated, you may proceed with the transaction. Do you want to continue?");
                    }
                  }
                  else {
                    $(".ClientSelect").val('').trigger('change');
                    this.CallAlertModal("We're currently unable to fetch your KRA status due to a temporary issue with CVL KRA services. If your KRA is already updated, you may proceed with the transaction. Do you want to continue?");
                  }
                }
              }
            }, (err: any) => {
              console.log(err)
              this.Loader.hide();
            });
          }
          else {
            this.FilterData.emit(filterData[0]);
          }
        }
      }
      else {
        this.FilterData_MFCentral.emit("");
      }

    }
  }

  onChangeClientSelect(event: any) {
    let ClientBasicInfoId = event.target.value;
    console.log("ClientbasicINfoId: " + ClientBasicInfoId);

  }

  ngOnChanges(changes: SimpleChanges) {

    if (!!this.IsClientSelected) {
      try {
        this.selectedClient = this.IsClientSelected;
        if (this.selectedClient != undefined) {
          this.clientFilterForm.controls['ClientBasicInfoId'].patchValue(`${this.selectedClient.ClientBasicInfoId}`);
          // $(".ClientSelect").prop("disabled", true);

          this.FilterData.emit(this.selectedClient)
        }
      }
      catch (err) {
        console.log("While Selecting client by Default Exception" + err);
      }
      //End By Devang Mehta
    }
  }

  //End By Devang mehta

  //aditya, to pass pan and ucc to diff reports , this method dynamically handles pan and ucc
  HandlePanUcc() {
    this.ClientDetails.valueChanges.pipe(
      debounceTime(300), // Optional: Add debounce to wait for the user to stop typing
      distinctUntilChanged((prev, curr) => {
        // Compare the values of both fields
        const panChanged = prev.Pan !== curr.Pan;

        // Return true if both are the same (no change), false otherwise
        var regax = new RegExp(IsValidPAN);
        return !panChanged && regax.test(curr.Pan);
      })
    ).subscribe(() => {
      const panControl = this.ClientDetails.get('Pan');
      // Emit values based on which control is valid
      if (this.ShowPan && panControl.valid) {
        // this.SearchClient();
        setTimeout(() => {
          // this.ClientId = "540786"
          if (!!this.ClientId) {
            if (window.location.pathname.includes('detailed-holding-report')
              && isNullOrUndefined(sessionStorage.getItem('ytuoiytuoi'))) {
              sessionStorage.setItem('ytuoiytuoi', this.EncrdecrService.setEncr(this.ClientDetails.controls["Pan"].value))
            }
            this.GetPanUcc.emit({ ClientId: this.ClientId, Isvalid: true });
          }
          else
            this.GetPanUcc.emit({ Isvalid: false });
        }, 300);
      }
    });
  }

  MakeVisiblePan() {
    this.isDisplayEmployeeName = false;
    this.isDisplaySubBrokerName = false;
    this.isDisplayEmpSubClientName = false;
    this.isDisplayEmpSubBrokerFamilyName = false;
    this.isDisplayClientName = false;
    this.isdisplayFamilyName = false;
    this.IsHeirarchyEmp = false;
    this.FilterType = 'ByPan'
    this.IsbyUnmaped = false;
    this.ShowPan = true;
    // this.FilterData.emit(undefined);
    this.GetPanUcc.emit(new DataOfPnUc())
    this.selectedItems = []
    // keep the toggle state of onSelectClientL() in sync with the cleared dropdown,
    // else re-selecting the same investor is treated as a de-select and no FilterData is emitted
    this.ClientResult = []
  }

  ClearFormData() {
    debugger
    console.log("Clear data clicked")
    this.isMultiSelect = false;
    this.ClientDetails.controls["Pan"].setValue("")
    this.HideReportData.emit(true);
    this.ClearDropDown();
    this.ngOnInit();

  }

  DisableShowReport()
  {
   this.SearchClient();
  }

  ReloadPage()
  {
    window.location.reload();
   
  }

}
